/**
 * Every trace channel, with what it covers. Adding a channel is one line here.
 */
export const TRACE_CHANNELS = {
  'conf-list':
    'Todos/calendar conference list: WS → store → render of Live/Join',
  'phone-call': 'Phone conference call state (YC-3005)',
  ws: 'WebSocket connection state and raw/emitted messages',
} as const;

export type TraceChannel = keyof typeof TRACE_CHANNELS;

export const isTraceChannel = (name: string): name is TraceChannel =>
  Object.prototype.hasOwnProperty.call(TRACE_CHANNELS, name);
